import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  ApiRequestError,
  Button,
  Header,
} from "@funcional/react-ui";
import { Private, SsoRolesEnum } from "@funcional/react-auth-ui";
import { ProgramFamilyCard } from "@pbm/programs-families/components";
import { IProgramFamily } from "@pbm/programs-families/contracts";
import { DiscountRulesList } from "@pbm/discount-rules/components";
import {
  useDeleteDiscountRule,
  useDiscountRules,
} from "@pbm/discount-rules/hooks";
import { useProgramFamily } from "@pbm/programs-families/hooks";

export default function ViewProgramFamilyPage() {
  let {
    programCode,
    programFamilyCode,
  }: { programCode: string; programFamilyCode: string } = useParams();
  const {
    status: familyStatus,
    data: familyData,
    error: familyError,
    isFetching: isFetchingFamily,
  } = useProgramFamily(programCode, programFamilyCode);
  const { status, data, error, isFetching, refetch } = useDiscountRules(
    programCode,
    programFamilyCode
  );
  const history = useHistory();

  const { mutateAsync } = useDeleteDiscountRule();
  const deleteDiscountRule = (row: any, id: number) => {
    if (!window.confirm("Tem certeza de que deseja excluir este registro?")) {
      return;
    }
    mutateAsync({ id: `${id}` } as any).then(() => refetch());
  };

  return (
    <>
      <Header
        title="Grupo de Produtos do Programa"
        buttons={
          <>
            <Private
              roles={[
                SsoRolesEnum.MASTER,
                SsoRolesEnum.SUPPORT,
                SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
                SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
              ]}
            >
              <Button
                variant="outlined"
                onClick={() =>
                  history.push(
                    `/pbm/programs/${programCode}/families/${programFamilyCode}/edit`
                  )
                }
              >
                Editar Grupo de Produtos
              </Button>
            </Private>

            <Private
              roles={[
                SsoRolesEnum.MASTER,
                SsoRolesEnum.SUPPORT,
                SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
                SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
              ]}
            >
              <Button
                color="primary"
                onClick={() =>
                  history.push(
                    `/pbm/programs/${programCode}/families/${programFamilyCode}/discount-rules/new`
                  )
                }
              >
                Nova Regra de Desconto
              </Button>
            </Private>
          </>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/pbm/programs", label: "Programas" },
            {
              path: `/pbm/programs/${programCode}`,
              label: programCode,
            },
            {
              path: `/pbm/programs/${programCode}/families`,
              label: "Grupos de Produtos",
            },
            { label: programFamilyCode },
          ]}
        />
      </Header>

      {familyStatus === "loading" ? (
        <ApiLoadingSpinner />
      ) : familyStatus === "error" ? (
        <ApiRequestError error={familyError} />
      ) : (
        <>
          {data ? (
            <ProgramFamilyCard programFamily={familyData as IProgramFamily} />
          ) : (
            <p>Grupo de produtos não encontrado.</p>
          )}
          {isFetchingFamily ? <ApiUpdatingSpinner /> : null}
        </>
      )}

      {status === "loading" ? (
        <ApiLoadingSpinner />
      ) : status === "error" ? (
        <ApiRequestError error={error} />
      ) : (
        <>
          <DiscountRulesList
            deleteRecord={deleteDiscountRule}
            programFamilyCode={programFamilyCode}
            programCode={programCode}
            data={(data?.edges || []).map(({ node }) => node)}
          />
          {isFetching ? <ApiUpdatingSpinner /> : null}
        </>
      )}
    </>
  );
}
